import { render, staticRenderFns } from "./FoodCounter.vue?vue&type=template&id=6e92fe96&"
import script from "./FoodCounter.vue?vue&type=script&lang=js&"
export * from "./FoodCounter.vue?vue&type=script&lang=js&"
import style0 from "./FoodCounter.vue?vue&type=style&index=0&id=6e92fe96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports